// import React from 'react';
// import { Link } from 'react-router-dom';
import moment from 'moment';
import { datePattern } from './constants';

const dateDisplayFormat = 'MM/DD/YYYY';

export const formatOrderDate = (rowData) => {
  if (rowData) {
    return moment(rowData.orderDate, datePattern).format(dateDisplayFormat);
  }
  return '';
};
